import React, { memo } from 'react'
import ControlledPickupDropoffSelect from 'transfix-form/components/ControlledPickupDropoffSelect'
import { useSavedLaneFormContext } from '../../context/SavedLaneFormContext'
import { getLaneErrorMessage } from '../../schema'

export interface IPickupDropoffFormSectionProps {}

const PickupDropoffFormSection = memo<IPickupDropoffFormSectionProps>(() => {
  /**
   * Form Context
   */
  const { control, errors } = useSavedLaneFormContext()
  const pickupError = getLaneErrorMessage(errors, 'pickup')
  const pickupRadiusError = getLaneErrorMessage(errors, 'pickupRadius')
  const dropoffError = getLaneErrorMessage(errors, 'dropoff')
  const dropoffRadiusError = getLaneErrorMessage(errors, 'dropoffRadius')

  return (
    <ControlledPickupDropoffSelect
      control={control}
      name='lane'
      PickupDropoffSelectProps={{
        enableAnyDropoff: true,
        errors: {
          pickup: pickupError,
          pickupRadius: pickupRadiusError,
          dropoff: dropoffError,
          dropoffRadius: dropoffRadiusError,
        },
      }}
    />
  )
})

export default PickupDropoffFormSection
